import { IconBaseProps } from "react-icons";
import { FiFolderPlus } from "react-icons/fi";

const AddFolderIcon = ({ ...rest }: IconBaseProps) => {
  return <FiFolderPlus {...rest} />;
};

export default AddFolderIcon;
